(function () {
    'use strict';

    var preloader = document.getElementById('preloader');
    if (!preloader) return;

    window.addEventListener('load', function () {
        var preloaderLogo = document.querySelector('.preloader__logo');
        var preloaderInner = document.querySelector('.preloader__inner');

        var preloaderTl = gsap.timeline({
            delay: 0.8,
            onComplete: function () {
                preloader.style.display = 'none';
                if (typeof ScrollTrigger !== 'undefined') {
                    ScrollTrigger.refresh();
                }
            }
        });

        preloaderTl
            .to(preloaderInner, {
                opacity: 0,
                y: -20,
                duration: 0.4,
                ease: 'power2.in'
            })
            .to(preloaderLogo, {
                opacity: 0.12,
                duration: 0.3,
                ease: 'power2.out'
            })
            .to(preloaderLogo, {
                scale: 60,
                opacity: 0,
                duration: 1.4,
                ease: 'power3.in'
            })
            .to(preloader, {
                opacity: 0,
                duration: 0.4,
                ease: 'power2.inOut'
            }, '-=0.5');
    });
})();
